import {API_METHODS} from "@/constant";

export const userReceiverSystemsApi = (
  _getAll,
  _get,
  _update,
  _create,
  _delete,
  _deleteWithBody,
  paramsIn
) => {
  return {

    [API_METHODS.GET_ALL_USER_RECEIVER_SYSTEM]: () => {
      let urlReq = `/UserReceiverSystem/${paramsIn.id}`;
      return _getAll(urlReq);
    },

    [API_METHODS.UPDATE_USER_RECEIVER_SYSTEM]: () => {
      let urlReq = `/UserReceiverSystem`;
      return _update(urlReq);
    },

    [API_METHODS.CREATE_USER_RECEIVER_SYSTEM]: () => {
      let urlReq = `/UserReceiverSystem`;
      return _create(urlReq);
    },

    [API_METHODS.DELETE_USER_RECEIVER_SYSTEM]: () => {
      let urlReq = `/UserReceiverSystem`;
      return _deleteWithBody(urlReq, {data: paramsIn.data});
    }
  };
};

